import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לשים לב לקול",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה להשתיק את הקול.",
      "אני רק שם/ה לב אליו.",
      "זה מספיק לרגע."
    ],
      [
      "היום אני לא מנסה להשתיק את הקול.",
      "אני רק שם/ה לב אליו.",
      "זה מספיק לרגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הקול הביקורתי מתעורר?",
      "מה הוא אומר לי בדרך כלל?",
      "איך זה מרגיש בגוף שלי?"
    ],
      [
      "מתי הקול הביקורתי מתעורר?",
      "מה הוא אומר לי בדרך כלל?",
      "איך זה מרגיש בגוף שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לשים לב לקול הוא כבר התחלה."
    ],
      [
      "לשים לב לקול הוא כבר התחלה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת עם המילים \"אני כאן\".",
      "נשימה אחת עם המילים \"אני כאן\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מאיפה הוא בא",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב מאיפה הקול הגיע.",
      "בלי האשמה.",
      "רק לראות."
    ],
      [
      "היום אני שם/ה לב מאיפה הקול הגיע.",
      "בלי האשמה.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "ממי למדתי את הקול הזה?",
      "מתי שמעתי אותו לראשונה?",
      "מה זה עשה לי אז?"
    ],
      [
      "ממי למדתי את הקול הזה?",
      "מתי שמעתי אותו לראשונה?",
      "מה זה עשה לי אז?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לראות את המקור מרכך את ההווה."
    ],
      [
      "לראות את המקור מרכך את ההווה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת על המקור.",
      "לכתוב מילה אחת על המקור."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "מה הוא מנסה למנוע",
    opening: localizedGenderNode(
      [
      "היום אני שואל/ת מה הקול מנסה למנוע.",
      "לא להצדיק.",
      "רק להבין."
    ],
      [
      "היום אני שואל/ת מה הקול מנסה למנוע.",
      "לא להצדיק.",
      "רק להבין."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הקול מפחד שיקרה אם ארפה?",
      "מה הוא מנסה לשמור עליי ממנו?",
      "מה המחיר של זה בשבילי?"
    ],
      [
      "מה הקול מפחד שיקרה אם ארפה?",
      "מה הוא מנסה לשמור עליי ממנו?",
      "מה המחיר של זה בשבילי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גם הקול הזה מנסה להגן עליי."
    ],
      [
      "גם הקול הזה מנסה להגן עליי."
    ]
    ),
    action: localizedGenderNode(
      "לומר לעצמי \"אני רואה אותך\".",
      "לומר לעצמי \"אני רואה אותך\"."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "החלק שנפגע",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לחלק שנפגע מהקול הזה.",
      "לא לתקן.",
      "רק להיות איתו."
    ],
      [
      "היום אני שם/ה לב לחלק שנפגע מהקול הזה.",
      "לא לתקן.",
      "רק להיות איתו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה הוא יושב בי?",
      "מה הוא בוחר/ת ממני עכשיו?",
      "איך זה מרגיש להיות איתו רגע?"
    ],
      [
      "איפה הוא יושב בי?",
      "מה הוא בוחר/ת ממני עכשיו?",
      "איך זה מרגיש להיות איתו רגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להיות איתו לרגע הוא כבר שינוי קטן."
    ],
      [
      "להיות איתו לרגע הוא כבר שינוי קטן."
    ]
    ),
    action: localizedGenderNode(
      "לשים יד על הלב ולנשום.",
      "לשים יד על הלב ולנשום."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "לראות את המחיר",
    opening: localizedGenderNode(
      [
      "היום אני רואה את המחיר שהקול גובה.",
      "לא להאשים.",
      "רק לראות."
    ],
      [
      "היום אני רואה את המחיר שהקול גובה.",
      "לא להאשים.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה המחיר שאני משלם/ת על הקול הזה?",
      "מה אני מפסיד/ה בדרך?",
      "מה הייתי רוצה שיהיה אחרת?"
    ],
      [
      "מה המחיר שאני משלם/ת על הקול הזה?",
      "מה אני מפסיד/ה בדרך?",
      "מה הייתי רוצה שיהיה אחרת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לראות את המחיר פותח מקום לשינוי קטן."
    ],
      [
      "לראות את המחיר פותח מקום לשינוי קטן."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת על המחיר.",
      "לכתוב מילה אחת על המחיר."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "לבקש רוך",
    opening: localizedGenderNode(
      [
      "היום אני מנסח/ת בקשה קטנה לרוך.",
      "לא גדולה.",
      "רק קטנה."
    ],
      [
      "היום אני מנסח/ת בקשה קטנה לרוך.",
      "לא גדולה.",
      "רק קטנה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך הייתי רוצה שידברו אליי?",
      "איך אני יכול/ה לדבר כך לעצמי?",
      "מה צעד קטן בכיוון?"
    ],
      [
      "איך הייתי רוצה שידברו אליי?",
      "איך אני יכול/ה לדבר כך לעצמי?",
      "מה צעד קטן בכיוון?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "רוך קטן יכול לפתוח נשימה."
    ],
      [
      "רוך קטן יכול לפתוח נשימה."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד רך לעצמי.",
      "משפט אחד רך לעצמי."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "להישאר עם עצמי",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להישאר עם עצמי מול הקול.",
      "לא לברוח.",
      "רק להיות."
    ],
      [
      "היום אני מתרגל/ת להישאר עם עצמי מול הקול.",
      "לא לברוח.",
      "רק להיות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה עוזר לי להישאר איתי?",
      "מה מוציא אותי מעצמי?",
      "מה יכול לעזור לי לחזור?"
    ],
      [
      "מה עוזר לי להישאר איתי?",
      "מה מוציא אותי מעצמי?",
      "מה יכול לעזור לי לחזור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להישאר איתי הוא תיקון קטן."
    ],
      [
      "להישאר איתי הוא תיקון קטן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת לפני תגובה.",
      "נשימה אחת לפני תגובה."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "גבול מול הקול",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת גבול קטן מול הקול.",
      "לא להילחם.",
      "רק לשמור."
    ],
      [
      "היום אני בודק/ת גבול קטן מול הקול.",
      "לא להילחם.",
      "רק לשמור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הכתפיים."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הכתפיים."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הקול חוצה גבול בשבילי?",
      "איזה משפט גבול היה עוזר?",
      "איך לומר אותו לעצמי?"
    ],
      [
      "מתי הקול חוצה גבול בשבילי?",
      "איזה משפט גבול היה עוזר?",
      "איך לומר אותו לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גבול קטן שומר על הלב."
    ],
      [
      "גבול קטן שומר על הלב."
    ]
    ),
    action: localizedGenderNode(
      "משפט גבול אחד לעצמי.",
      "משפט גבול אחד לעצמי."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "לשמוע גם קול אחר",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת אם יש בי קול נוסף.",
      "קטן.",
      "אבל קיים."
    ],
      [
      "היום אני בודק/ת אם יש בי קול נוסף.",
      "קטן.",
      "אבל קיים."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אומר לי קול עדין יותר?",
      "מתי אני שומע/ת אותו?",
      "איך זה מרגיש לשמוע אותו?"
    ],
      [
      "מה אומר לי קול עדין יותר?",
      "מתי אני שומע/ת אותו?",
      "איך זה מרגיש לשמוע אותו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קול עדין אחד יכול לפתוח מרחב."
    ],
      [
      "קול עדין אחד יכול לפתוח מרחב."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב משפט עדין אחד.",
      "לכתוב משפט עדין אחד."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "לבקש מגע רך",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך לבקש מגע רך.",
      "לא דרמה.",
      "בקשה קטנה."
    ],
      [
      "היום אני בודק/ת איך לבקש מגע רך.",
      "לא דרמה.",
      "בקשה קטנה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה מגע רך חסר לי?",
      "איך אפשר לבקש זאת בעדינות?",
      "מה צעד קטן בכיוון?"
    ],
      [
      "איזה מגע רך חסר לי?",
      "איך אפשר לבקש זאת בעדינות?",
      "מה צעד קטן בכיוון?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת יכולה לרכך."
    ],
      [
      "בקשה אחת יכולה לרכך."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט אחד.",
      "לכתוב את הבקשה במשפט אחד."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "ערך אחד מעבר לביקורת",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת ערך אחד מעבר לקול הביקורתי.",
      "קטן.",
      "אבל אמיתי."
    ],
      [
      "היום אני מחפש/ת ערך אחד מעבר לקול הביקורתי.",
      "קטן.",
      "אבל אמיתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה ערך חשוב לי באמת?",
      "איך הערך הזה נראה ביום רגיל?",
      "מה צעד קטן שיכבד אותו?"
    ],
      [
      "איזה ערך חשוב לי באמת?",
      "איך הערך הזה נראה ביום רגיל?",
      "מה צעד קטן שיכבד אותו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ערך אחד יכול להיות עוגן."
    ],
      [
      "ערך אחד יכול להיות עוגן."
    ]
    ),
    action: localizedGenderNode(
      "מילה אחת שמבטאת את הערך.",
      "מילה אחת שמבטאת את הערך."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "להקשיב לי",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להקשיב לי מול הקול הביקורתי.",
      "לא לדחות.",
      "רק לשמוע."
    ],
      [
      "היום אני מתרגל/ת להקשיב לי מול הקול הביקורתי.",
      "לא לדחות.",
      "רק לשמוע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני בוחר/ת/ה לשמוע מעצמי היום?",
      "מה אני נותן/ת לאחרים שאני לא נותן/ת לי?",
      "איך אפשר לתת את זה לעצמי?"
    ],
      [
      "מה אני בוחר/ת/ה לשמוע מעצמי היום?",
      "מה אני נותן/ת לאחרים שאני לא נותן/ת לי?",
      "איך אפשר לתת את זה לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להקשיב לי הוא תיקון קטן."
    ],
      [
      "להקשיב לי הוא תיקון קטן."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד עדין לעצמי.",
      "משפט אחד עדין לעצמי."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "צעד קטן של קבלה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן של קבלה.",
      "בלי דרמה.",
      "צעד קטן."
    ],
      [
      "היום אני בוחר/ת צעד קטן של קבלה.",
      "בלי דרמה.",
      "צעד קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ],
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "צעד קטן מספיק כדי לזוז."
    ],
      [
      "צעד קטן מספיק כדי לזוז."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד אחד קטן ולזכור אותו.",
      "לבחור צעד אחד קטן ולזכור אותו."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת משפט שמחזיר אותי לרוך פנימי.",
      "כשאני נשפט/ת.",
      "משפט קטן."
    ],
      [
      "היום אני בוחר/ת משפט שמחזיר אותי לרוך פנימי.",
      "כשאני נשפט/ת.",
      "משפט קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על הקול הזה?",
      "מה הסימן הראשון שהוא חוזר?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ],
      [
      "מה למדתי על הקול הזה?",
      "מה הסימן הראשון שהוא חוזר?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה לשמוע ביקורת ולהישאר עם עצמי."
    ],
      [
      "אני יכול/ה לשמוע ביקורת ולהישאר עם עצמי."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט החדש פעם אחת.",
      "לומר את המשפט החדש פעם אחת."
    ),
  },
].map(buildNormalizedDay);

export const harshCriticismOfAParentThatLivesInsideMeToThisDayBlueprintHe = buildNormalizedPilotBlueprint({
  id: "harsh_criticism_of_a_parent_that_lives_inside_me_to_this_day_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "harsh_criticism_of_a_parent_that_lives_inside_me_to_this_day",
  category: "childhood_parents_past_wounds",
  journeyName: {
    he: "ביקורתיות חריפה של הורה שחיה בתוכי עד היום",
    en: "Harsh criticism of a parent that lives inside me to this day",
    es: "Crítica dura de un padre que vive dentro de mí hasta hoy",
  },
  days,
});

export default harshCriticismOfAParentThatLivesInsideMeToThisDayBlueprintHe;
